import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["message", "box"]

  static values = {
    userId: Number
  }

  connect() {
    console.log("chat message controller connected")
    const userId = Number(document.body.dataset.currentUserId)
    console.log("User ID:", userId)
    console.log("Message User ID:", this.userIdValue)
    if (userId === this.userIdValue) {
      console.log("User ID is the same as the message user ID")
      this.messageTarget.classList.add("justify-end")
      this.boxTarget.classList.remove("bg-blue-500")
      this.boxTarget.classList.add("bg-green-500")
    }

    this.scrollToBottom()
  }

  scrollToBottom() {
    const container = document.getElementById("messages")
    if (container) {
      container.scrollTop = container.scrollHeight
    }
  }
} 